<div class="flex flex-col gap-2.5 p-4">
  <div class="mb-4 text-center text-base font-semibold">
    Highlighted Network Measurements
  </div>

  <div
    class="flex items-center justify-between rounded-xl px-4 py-5 text-base"
    [ngClass]="{
      'bg-orange-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Latency:</span>
    <span class="font-semibold">{{ latency }}ms</span>
  </div>

  <div
    class="flex items-center justify-between rounded-xl px-4 py-5 text-base"
    [ngClass]="{
      'bg-orange-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Jitter:</span>
    <span class="font-semibold">{{ jitter }}ms</span>
  </div>

  <div
    class="flex items-center justify-between rounded-xl px-4 py-5 text-base"
    [ngClass]="{
      'bg-orange-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Packet Loss:</span>
    <span class="font-semibold">{{ packetLost }}%</span>
  </div>
</div>
